import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser } from '../Login/selectors';
import Avatar from '../Avatar';
import { Button, Muted } from '../Controls';
import { Page, PageTitle, Panel, PanelTitle } from '../Page';
import { removeAvatar, setAvatar } from './actions';
import { logout } from '../Login/actions';
import PushSettings from '../Push/PushSettings';

/** Your profile: your picture, shown to the people you play, notifications, and logging out. */
const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const saving = useSelector((state) => state.profile.saving);
  const chooser = useRef(null);

  if (!user) {
    return null;
  }

  return (
    <Page>
      <PageTitle>Profile</PageTitle>
      <Panel>
        <PanelTitle>Your picture</PanelTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 8 }}>
          <Avatar user={user} size={96} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <strong>{user.get('name')}</strong>
            <input
              ref={chooser}
              type="file"
              accept="image/*"
              hidden
              onChange={(event) => {
                const file = event.target.files[0];
                if (file) {
                  dispatch(setAvatar(file));
                }
                event.target.value = '';
              }}
            />
            <Button $primary onClick={() => chooser.current.click()} disabled={saving}>
              {saving ? 'Saving…' : user.get('avatar') ? 'Change picture' : 'Add a picture'}
            </Button>
            {user.get('avatar') && <Button onClick={() => dispatch(removeAvatar())} disabled={saving}>Remove</Button>}
          </div>
        </div>
        <Muted>Your opponents see it next to your name. It's cropped to a square from the middle.</Muted>
      </Panel>
      <PushSettings />
      <Panel>
        <Button onClick={() => dispatch(logout())}>Log out</Button>
      </Panel>
    </Page>
  );
};

export default Profile;
